import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { g as getLocale, o as transDialog } from './utils2.js';
import { d as defineCustomElement$1 } from './mapy-review-button2.js';

const mapyReviewQuestionCss = ".mapy-review-question{font-family:Arial;display:flex;flex-direction:column;gap:24px}.default-btn{cursor:pointer;border-radius:4px;border:1px solid #E5E5E5;padding:6px 12px;background:#fff;font-size:14px;font-style:normal;font-weight:400;line-height:24px;height:36px;box-sizing:border-box}.default-btn:hover{border-color:#6E6E6E}h3{color:#000;text-align:center;font-size:18px;font-style:normal;font-weight:700;line-height:140%;margin:0}.buttons{display:flex;flex-direction:column;gap:8px}.position{margin:0;text-align:center;color:#6E6E6E;font-size:12px;font-style:normal;font-weight:400;line-height:16px;}";
const MapyReviewQuestionStyle0 = mapyReviewQuestionCss;

var __classPrivateFieldSet = (undefined && undefined.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m")
        throw new TypeError("Private method is not writable");
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f)
        throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver))
        throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MapyReviewQuestion_lang;
const MapyReviewQuestion = /*@__PURE__*/ proxyCustomElement(class MapyReviewQuestion extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.answer = createEvent(this, "answer", 1);
        _MapyReviewQuestion_lang.set(this, "");
        this.onYesClick = () => {
            this.answer.emit("yes");
        };
        this.dontKnowClick = () => {
            this.answer.emit("dont_know");
        };
        this.noClick = () => {
            this.answer.emit("no");
        };
        this.service = "mapy";
        this.question = "";
        this.questPos = 1;
        this.questCount = 0;
    }
    componentWillLoad() {
        __classPrivateFieldSet(this, _MapyReviewQuestion_lang, getLocale(this.hostElement), "f");
    }
    render() {
        return (h(Host, { key: '49cbf529071a289005d7cf2f5c348fce7d9519f1' }, h("div", { key: '5de245b7f95785ab08a86f967111613ef08c8419', class: "mapy-review-question" }, h("h3", { key: '01425455af0249979b038347da830b6ab88702d6' }, this.question), h("div", { key: '54d3f8527e7de021aaf4dd042255a609be53ed39', class: "buttons" }, this.questPos === 1 && h("mapy-review-button", { key: '2e386c058ff0c255ab51dd784a549b3dc8330027', onClick: this.onYesClick, service: this.service }, transDialog(__classPrivateFieldGet(this, _MapyReviewQuestion_lang, "f"), "responseYes")), this.questPos !== 1 && h("button", { key: '3d8237cc829b374d2297b86794d47f0db269cdb9', class: "default-btn", type: "button", onClick: this.onYesClick }, transDialog(__classPrivateFieldGet(this, _MapyReviewQuestion_lang, "f"), "responseYes")), h("button", { key: 'b259c4e7bdd90817f64b8c4a0498187943fc1bd7', class: "default-btn", type: "button", onClick: this.dontKnowClick }, transDialog(__classPrivateFieldGet(this, _MapyReviewQuestion_lang, "f"), "responseDontKnow")), h("button", { key: '74cc8922552f0c4f1b5291688c2041adef99830d', class: "default-btn", type: "button", onClick: this.noClick }, transDialog(__classPrivateFieldGet(this, _MapyReviewQuestion_lang, "f"), "responseNo"))), h("p", { key: '3d55e84a54b4e5fee5a8db42c8fd45b09e5d75d3', class: "position" }, transDialog(__classPrivateFieldGet(this, _MapyReviewQuestion_lang, "f"), "questionsPosition", {
            current: this.questPos,
            total: this.questCount,
        })))));
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewQuestionStyle0; }
}, [1, "mapy-review-question", {
        "service": [513],
        "question": [513],
        "questPos": [514, "quest-pos"],
        "questCount": [514, "quest-count"]
    }]);
_MapyReviewQuestion_lang = new WeakMap();
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-question", "mapy-review-button"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-question":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewQuestion);
            }
            break;
        case "mapy-review-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewQuestion as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-question2.js.map